/**
 * Labour on a quotation is one duration plus an hourly rate.
 * Mobile stores hour and minute together in `duration`. The web form stores whole hours.
 * The two only agree once we compare them to the labour cost (rate × time).
 */

const MONEY_TOLERANCE = 0.05;

const close = (a: number, b: number) => Math.abs(a - b) < MONEY_TOLERANCE;

function formatHours(hours: number): string {
  return `${hours} h`;
}

function formatMinutes(totalMinutes: number): string {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours === 0) return `${minutes} min`;
  if (minutes === 0) return `${hours} h`;
  return `${hours} h ${minutes} min`;
}

export function formatQuotationDuration(
  duration: number | null | undefined,
  hourlyRate?: number | null,
  laborCost?: number | null
): string {
  if (duration == null || Number.isNaN(Number(duration))) return "-";
  const total = Math.trunc(Number(duration));
  if (total < 0) return "-";

  const rate = Number(hourlyRate);
  const cost = Number(laborCost);
  if (Number.isFinite(rate) && rate > 0 && Number.isFinite(cost)) {
    const countedAsHours = close(total * rate, cost);
    const countedAsMinutes = close((total / 60) * rate, cost);
    if (countedAsMinutes && !countedAsHours) return formatMinutes(total);
    if (countedAsHours && !countedAsMinutes) return formatHours(total);
  }

  return String(total);
}

export function formatQuotationAmount(value: number | null | undefined): string {
  if (value == null || Number.isNaN(Number(value))) return "-";
  return String(value);
}
